// extracted by mini-css-extract-plugin
module.exports =  {"root":"ECFmDHlv0HzaSS0aM52a"};